module.exports = __webpack_public_path__ + "static/media/many-animals.a5055207.jpg";